<template>
  <div id="container">
      <Spinner :show="loading"></Spinner>
      <Header></Header>
      <Modal v-if="modal.title" :title="modal.title" :body="modal.body" :centerBody="modal.centerBody" :className="modal.className" :buttons="modal.buttons"></Modal>
      <section ref="content" id="content" class="section">
        <Notification v-if="notification.show" :text="notification.text" :className="notification.className"></Notification>
        <QrScanner ref="qrScanner" :className.sync="qrScanner.className"></QrScanner>
        <div class="columns is-mobile is-centered">
            <div class="column is-full has-text-centered">
                <div class="field">
                    <label class="label">{{ $t("Tap") }}</label>
                    <div class="control has-icons-left has-icons-right">
                        <div class="select is-fullwidth">
                            <select ref="asset" v-model="assetID" required>
                                <option disabled value="disabled">{{ $t("Tap")}}</option>
                                <option v-for="asset in assets" :key="asset.assetID" :value="asset.assetID">{{ asset.name }} ({{ asset.connected ? $t("Online") : $t("Offline") }})</option>
                            </select>
                        </div>
                        <div class="icon is-small is-left">
                            <i class="fa fa-tint"></i>
                        </div>
                        <div @click="scanQr('oldTag')" :title="$t('ClickToScanQrCode')" class="icon clickable is-small is-right">
                            <i class="fa fa-qrcode"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns is-mobile is-centered">
            <div class="column is-full has-text-centered">
                <div class="field">
                    <label class="label">{{ $t("Litres") }}</label>
                    <div class="control">
                        <input ref="amount" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input" type="number" :placeholder="$t('Litres')" required step="1" v-model.number="amount" min="1">
                    </div>
                </div>
            </div>
        </div>
        <div class="columns is-mobile is-centered">
            <div class="column is-half has-text-centered">
                <a @click="send()" class="button is-primary is-fullwidth">
                    <span class="icon">
                        <i class="fa fa-exchange"></i>
                    </span>
                    <span>{{ $t("Send") }}</span>
                </a>
            </div>
            <div class="column is-half has-text-centered">
                <a @click="$router.go(-1)" class="button is-info is-fullwidth">
                    <span class="icon">
                        <i class="fa fa-arrow-left"></i>
                    </span>
                    <span>{{ $t("Back") }}</span>
                </a>
            </div>
        </div>
      </section>
  <NavigationTabs></NavigationTabs>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Modal from "@/components/Modal.vue";
import Notification from "@/components/Notification.vue";
import QrScanner from "@/components/QrScanner.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import Spinner from "@/components/Spinner.vue";

export default {
  name: "TagTopup",
  components: {
    Header,
    Modal,
    Notification,
    QrScanner,
    NavigationTabs,
    Spinner
  },
  mounted: async function() {
    const response = await this.$http.get(`/Asset?waterSystemId=${this.user.systemID}`);
    this.assets = response.data.assets;
    this.assetID = this.user.assetID;
    this.amount = 1;
    await this.updateUser();
  },
  data () {
      return {
          assets: [],
          assetID: null,
          minTransfer: 0,
          amount: 0,
          modal: {
              title: null,
              body: null,
              centerBody: true,
              className: "",
              buttons: []
          },
          qrScanner: {
              className: ""
          }
      }
  },
  methods:
  {
      scanQr: function() {
        this.$refs.qrScanner.scanQr();
      },
      qrResult: async function(result) {
        try
        {
            const response = await this.$http.get(`/Asset/FromBarcode?barcode=${result}`);
            const _asset = response.data.asset;

            for(const asset of this.assets)
            {
                if(asset.assetID == _asset.assetID)
                {
                    this.assetID = _asset.assetID;
                    return;
                }
            }

            this.assets.unshift(_asset);
            this.assetID = _asset.assetID;
        }

        catch(error)
        {
            alert("Couldn't find tap from QR code.")
        }
      },
      send: function() {
        const amount = parseFloat(this.amount);

        if (isNaN(amount) || amount < parseFloat(this.minTransfer)) {
            this.$refs.amount.reportValidity();
            return;
        }

        if(this.$refs.asset.selectedOptions[0].className.split(" ").indexOf("Online") == -1)
        {
            alert(this.$t("CantSelectThisTap"));
            return;
        }

        this.modal.title = this.$t("AreYouSure");
        this.modal.body = `<p>${this.$t("DispenseInfo", {amount: `${this.amount} ${this.$t("Litres")}`, tap: this.$refs.asset.selectedOptions[0].innerHTML})}</p>`;
        this.modal.buttons =
        [
            {id: 0, title: this.$t("Yes"), className: "is-primary", click: this.doSend},
            {id: 1, title: this.$t("No"), className: "is-info", click: () => { this.modal.className = ""; }}
        ];
        this.modal.className = "is-active";
      },
      doSend: async function() {
        if(this.loading)
        {
            return;
        }

        this.modal.body += `<br><h2 class="is-size-2">${this.$t("PleaseWait")}</h2>`;
        this.modal.buttons = [];

        try
        {
            const response = await this.$http.post(`/Asset/${this.assetID}`,
            {
                litres: this.amount
            });

            alert(this.$t("WaterHasBeenDispensed"));
        }

        catch(error)
        {
            if(error && error.response)
            {
                alert(error.response.data.message)
            }
        }

        await this.updateUser();
        this.modal.className = "";
      }
  }
};
</script>
